import React, { useEffect, useState,useRef } from "react";
import { createFormBuilderLink } from "../../../helpers";
import { Button, IconButton, Box, TextField, Typography, Checkbox, FormControlLabel, FormControl,
   FormLabel, FormHelperText, AppBar, Toolbar, Dialog, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import SaveOutlined from "@mui/icons-material/SaveOutlined";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateAssetBuilder, UpdateAssetBuilder, getAssetById } from "../../../REST/assets";
import { CreateForms } from "../../../REST/utilities";
import CircularProgress from '@mui/material/CircularProgress';
import { useMediaQuery, useTheme } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CreateAsset = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [formId, setFormId] = useState(null);
  const [fullscreenSection, setFullscreenSection] = useState(null); // Track fullscreen state
  const frame = useRef(null)
  const [saving,setSaving] = useState(false)

  const isAddMode = location.pathname === "/settings/asset/createAsset";
  const id = isAddMode ? null : location.pathname.replace("/settings/asset/createAsset/", "");

  useEffect(() => {
    if (!isAddMode) {
      getAssetById(id)
        .then((res) => {
          const data = res?.data;
          setFormId(data.formId);
          const fields = ["name", "description", "status", "color", "formId"];
          fields.forEach((field) => {
            setValue(field, data[field]);
          });
        })
        .catch(() => {
          navigate("/settings/asset");
        });
    } else {
      CreateForms().then(({ data }) => {
        setValue("formId", data._id);
        setFormId(data._id);
      });
    }
  }, []);

  const schema = yup.object({
    name: yup.string().trim().required("Name is required"),
    description: yup.string().trim().required("Description is required"),
    formId: yup.string().required("Form ID is required"),
    status: yup.boolean().required(),
    color: yup.string().required("Color is required"),
  });

  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const rancolor = getRandomColor();

  const { control, setValue, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      color: rancolor,
      name: "",
      status: true,
      description: "",
      formId: null,
    },
    resolver: yupResolver(schema),
  });
  const afterSave = (res)=>{
    const data = res?.data;
    setFormId(data.formId);
    const fields = ["name", "description", "status", "color", "formId"];
    fields.forEach((field) => {
      setValue(field, data[field]);
    });
    setSaving(false)
  }
  const saveForm = (data) => {
    setSaving(true)
    saveFrame()
    .then(()=>{
      const newRecord = { ...data };
      if (isAddMode) {
        CreateAssetBuilder(newRecord).then(afterSave);
      } else {
        UpdateAssetBuilder(id, newRecord).then(afterSave);
      }
    })
    
  };

  const handleClose = () => {
    navigate("/settings/asset/");
  };

  const toggleFullscreen = (section) => {
    setFullscreenSection(fullscreenSection === section ? null : section);
  };
  const saveFrame = ()=>{
    frame.current.contentWindow.postMessage("callSave","*");


    return new Promise((resolve, _) => {
      setTimeout(()=>{
       
        resolve()
        
      },3000)
    })

    
    
  }
  return (
    <Dialog fullScreen open={true} onClose={handleClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar style={{ justifyContent: "space-between" }}>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {isAddMode ? "Add New " : "Update "} Master Asset
          </Typography>
          <IconButton edge="start" color="inherit" onClick={handleSubmit(saveForm)}>
              {
                saving ? (     <CircularProgress color='error' />  ) : (    <SaveOutlined />       )
              }
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        display="flex"
        width="100%"
        flex="1 1 auto"
        minHeight={0}
        flexDirection={isMobile ? "column" : "row"}
        sx={{
          overflow: isMobile ? "auto" : "hidden",
        }}
      >
        {(!fullscreenSection || fullscreenSection === "left") && (
          <Box
            width={isMobile ? "100%" : (fullscreenSection ? "100%" : "30%")}
            height={isMobile ? "auto" : "100%"}
            p={2}
            position="relative"
            sx={{
              transition: "width 0.3s ease",
              overflowY: isMobile ? "visible" : "auto",
              borderRight: !isMobile && !fullscreenSection ? `1px solid ${theme.palette.divider}` : "none",
              borderBottom: isMobile && !fullscreenSection ? `1px solid ${theme.palette.divider}` : "none",
              flex: "0 0 auto",
            }}
          >
            
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="dense"
                  error={Boolean(errors.name)}
                  helperText={errors.name?.message}
                  fullWidth
                  label="Name"
                  {...field}
                />
              )}
            />
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <TextField
                  margin="dense"
                  error={Boolean(errors.description)}
                  helperText={errors.description?.message}
                  fullWidth
                  label="Description"
                  {...field}
                />
              )}
            />
            <Controller
              name="color"
              control={control}
              render={({ field }) => (
                <FormControl error={Boolean(errors.color)} margin="dense" fullWidth>
                  <FormLabel>Pick a Color</FormLabel>
                  <input
                    type="color"
                    {...field}
                    style={{
                      height: "40px",
                      width: "100px",
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                    }}
                  />
                  {errors.color && <FormHelperText>{errors.color.message}</FormHelperText>}
                </FormControl>
              )}
            />
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  {...field}
                  control={<Checkbox checked={field.value} />}
                  label="Is Enabled?"
                />
              )}
            />
        
          </Box>
        )}
        {(!fullscreenSection || fullscreenSection === "right") && (
          <Box
            width={isMobile ? "100%" : (fullscreenSection ? "100%" : "70%")}
            height={isMobile ? (fullscreenSection === "right" ? "100%" : "75dvh") : "100%"}
            padding={2}
            position="relative"
            sx={{
              transition: "width 0.3s ease",
              flex: isMobile ? "0 0 auto" : "1 1 auto",
              minHeight: isMobile ? 420 : 0,
            }}
          >
            <IconButton
              style={{ position: "absolute", bottom: 8, right: 8 }}
              onClick={() => toggleFullscreen("right")}  color="primary" title="Full Screen"
            >
              {fullscreenSection === "right" ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
            {formId && (
              <iframe ref={frame}
                src={createFormBuilderLink("build", formId)}
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                width="100%"
                height="100%"
                title="Template Editor"
                scrolling="auto"
              />
            )}
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

export default CreateAsset;
